import ItemSearchService from '@/services/itemSearch.service'
import { TokenService } from '@/services/storage.service'
import router from '@/router'

const state =  {
    userItemAdvancedSearchParams: null
}

const getters = {
    userItemAdvancedSearchParams (state) {
        return state.userItemAdvancedSearchParams
    }

}

const actions = {
    async searchItemAdvanced({commit}, payload) {
        try {
            // console.log(payload)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await ItemSearchService.searchItemAdvanced(payload);
            commit('setLoading', false, { root: true })            


            return result
        } catch (e) {
            // console.log(e)
            return e
        }
    },
    async searchItemByNumber({commit}, payload) {
        try {
            // console.log(payload)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await ItemSearchService.searchItemByNumber(payload);
            commit('setLoading', false, { root: true })            


            return result
        } catch (e) {
            // console.log(e)
            return e
        }
    },
    async searchItemByCatalogNumber({commit}, payload) {
        try {
            // console.log(payload)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await ItemSearchService.searchItemByCatalogNumber(payload);
            commit('setLoading', false, { root: true })            


            return result
        } catch (e) {
            // console.log(e)
            return e
        }
    },
    async searchItemPrices({commit}, payload) {
        try {
            console.log(payload)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await ItemSearchService.searchItemPrices(payload);
            commit('setLoading', false, { root: true })            


            return result
        } catch (e) {
            // console.log(e)
            return e
        }
    },
 }

const mutations = {
    setUserItemAdvancedSearchParams (state, payload) {
        state.userQuoteSearchParams = payload
    }

}

export const itemSearch = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}